import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../../shared/shared.service';

@Component({
  selector: 'app-customer-report',
  templateUrl: './customer-report.component.html',
  styleUrls: ['./customer-report.component.css']
})
export class CustomerReportComponent implements OnInit {
  displayedColumns : ['srNo','sih_Date', 'openingBalance', 'ern_points', 'redm_points', 'ex_points', 'issue_points', 'closing_value'];
  printWindow: Window | null = null;
  dataSource :any;
  customerData: any;
  currentDateAndTime = new Date();
  transactionStartDate : any ;
  transactionEndDate : any ;
  isLoaderShow = false  ;
  constructor(
    public dialogRef: MatDialogRef<CustomerReportComponent>,
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) private confModel: any
  ) {
    this.customerData = confModel.customerData ;
  }

  ngOnInit() {
    this.isLoaderShow = true;
    this.sharedService.customGetApi('CustomerRewardPoint/RewardPointData?strmob=' + this.customerData.pm_Mob ).subscribe((data) => {
       this.dataSource = data;
       const timestamps = this.dataSource.map(item => new Date(item.sih_Date).getTime());
this.transactionStartDate = Math.min(...timestamps);
this.transactionEndDate = Math.max(...timestamps);
        this.isLoaderShow = false;
      });    
  }
  onDownloadPdf() {
  const printWindow =  window.open('', '', '_blank');
  printWindow.document.open();
  printWindow.document.write(`<html><head><title>Customer Reward Point Ledger</title> <link rel="stylesheet" href="/assets/css/customer-report.css"> </head><body onload="window.print(); window.close();">${document.querySelector('.customer-rewardPoints').innerHTML}</body></html> `);
  printWindow.document.close();
}
}